var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { load } from "framework/state/loader";
import { updateByCollectionResponse } from "framework/state/collection";
import { NoEntityError } from "framework/validation/validatableentity";
import { apiGetOfficialCompetitionAttendance } from "./endpoint";
import { groupOfficialAttendancesByEventId } from "./entity";
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), events: [], openedDetailedInfoForEventIds: [] });
var loadOfficialRegistrations = function (idt) { return function (store) {
    var loader = function () { return apiGetOfficialCompetitionAttendance(idt); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByCollectionResponse(draft, response);
            draft.events = groupOfficialAttendancesByEventId(draft.collection);
            draft.openedDetailedInfoForEventIds = [];
        });
    };
    load(store, loader, stateProducer);
}; };
var openOrCloseEventDetail = function (eventId) { return function (store) {
    store.setState(function (draft) {
        var idx = draft.openedDetailedInfoForEventIds.indexOf(eventId);
        if (idx >= 0) {
            draft.openedDetailedInfoForEventIds.splice(idx, 1);
        }
        else {
            draft.openedDetailedInfoForEventIds.push(eventId);
        }
    });
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        loadOfficialRegistrations: loadOfficialRegistrations,
        openOrCloseEventDetail: openOrCloseEventDetail,
    },
    name: "OfficialCompetitionAttendance"
});
var useState = createHook(store);
export { StateDefaults as OfficialCompetitionAttendanceDefaults, useState as useOfficialCompetitionAttendance, };
